

if ($('#shopify-bundle-builder').length) {
    window.boxLocalStorageId = 'glazehw_boxes_v1';

    let app = {
        ready: false,
        mounted: false,
        activeTab: 'bundle-builder-section-tab-1',
        products: [],
        purchase_type: 'onetime',
        purchase_value: 0,
        collapsedMobileBag: true,
        processingBag: false,
        isEditMode: false,
        editBoxId: null,
        init: function() {
            this.mounted = true;
            this.ready = true;
            this.checkEditMode();
            this.bindEvents();
        },
        checkEditMode: async function() {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const boxId = parseInt(urlParams.get('box'));
                if (boxId) {
                    const glazehwBoxes = localStorage.getItem(window.boxLocalStorageId) ? JSON.parse(localStorage.getItem(window.boxLocalStorageId)) : false;
                    if (glazehwBoxes && glazehwBoxes[boxId - 1].length) {
                        const productToLoad = glazehwBoxes[boxId - 1];
                        productToLoad.forEach((product) => {
                            for (let index = 0; index < product.quantity; index++) {
                                try {
                                    const foundProduct = window.productsBundle.reduce((found, _product) => {
                                        if (!found) {
                                            const variant = _product.variants.find((variant) => variant.id === product.id);
                                            if (variant) return _product;
                                        }
                                        return found;
                                    }, null);
                                    app.addToBundle(foundProduct.id);
                                } catch (error) {
                                    console.log(error);
                                }
                            }
                            app.editBoxId = boxId;
                            app.isEditMode = true;
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        switchTab: function(tabIndex) {

          const selectedSection = $(`#bundle-builder-section-tab-${tabIndex}`);
if (selectedSection.length) {
    $('html, body').animate({
        scrollTop: selectedSection.offset().top - 120
    }, 'smooth');
}

$('.builder-hidden-scroll button').each(function() {
    $(this).removeClass('!bg-[#C1803E] text-white').addClass('bg-transparent border-[#C1803E] text-[#C1803E]');
});

const selectedButton = $(`#bundle-builder-section-${tabIndex}`);
if (selectedButton.length) {
    selectedButton.removeClass('bg-transparent border-[#C1803E] text-[#C1803E]').addClass('!bg-[#C1803E] text-white');
}

          
       
        },
        addToBundle: function(product,type,current_variant) {
            try {
  


                let _product = window.productsBundle.filter(p => p.id === product)[0];
              if(current_variant != undefined || current_variant != null )
                _product = { ..._product, ...{ type: type }, ...{ uid: Math.random().toString(16).slice(2) }, ...{ first_available_variant: current_variant } };
else _product = { ..._product, ...{ type: type }, ...{ uid: Math.random().toString(16).slice(2) }};
                    let $prod = `<div class="added-product">
   <div class="rounded-lg border-2 border-[#de7846] relative">
      <button class="absolute -top-2 -right-2 w-4 text-white z-10 bg-black rounded-full remove-bundle" data-uid="${_product.uid}" data-type="${type}">
         <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="w-full">
            <path clip-rule="evenodd" fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"></path>
         </svg>
      </button>
      <div class="py-[50%] relative">
         <div class="absolute bg-[#de7846] inset-0 opacity-30"></div>
         <div class="absolute inset-0"><img src="${_product.first_available_variant.featured_image ? _product.first_available_variant.featured_image.src : _product.featured_image}&amp;width=100" width="200" height="300"  loading="lazy" class="w-auto h-full mx-auto"></div>
      </div>
   </div>
   <h5 class="text-center text-xs m-0 mt-2 p-0 font-vinyl font-light leading-3 line-clamp-2"> ${_product.title} ${type == 'hinges' ? 'x2' : type == 'clamps' ? 'x3' : type == 'drills' ? 'x10' : 'x1' }</h5>

</div>`;
              
              if(type == 'hinges'){
                $('.replace-hinges').not('.replaced').html('');
                $('.replace-hinges').addClass('replaced');
               $('.replace-hinges').append($prod);
                $('#bundle-builder-section-tab-1 .add-to-bundle').addClass('disabled').attr('disabled', true);
              }
              else if(type == 'handles'){

                $('.replace-handles').not('.replaced').html('');
                $('.replace-handles').addClass('replaced');
               $('.replace-handles').append($prod);
                $('#bundle-builder-section-tab-2 .add-to-bundle').addClass('disabled').attr('disabled', true);
              } else if(type == 'clamps'){
                $('.replace-clamps').not('.replaced').html('');
                $('.replace-clamps').addClass('replaced');
               $('.replace-clamps').append($prod);
                $('#bundle-builder-section-tab-3 .add-to-bundle').addClass('disabled').attr('disabled', true);
              }else{
                $('.replace-optional').not('.replaced').html('');
                $('.replace-optional').addClass('replaced');
               $('.replace-optional').append($prod);
              }


            if ($('.replace-hinges.replaced .added-product').length > 0 && $('.replace-clamps.replaced .added-product').length > 0 && $('.replace-handles.replaced .added-product').length> 0) $('.add-to-bag').removeClass('disabled').removeAttr('disabled');
                else $('.add-to-bag').addClass('disabled').attr('disabled',true);
              
              
                app.products.push(_product);
                app.purchase_value = app.products.map(t => t.first_available_variant.price).reduce((add, current) => add + current, 0);

              
            } catch (error) {
                console.log(error);
            }
        },
        removeFromBundle: function(uid) {
            app.products = app.products.filter(p => p.uid !== uid);
            app.purchase_value = app.products.map(t => t.first_available_variant.price).reduce((add, current) => add + current, 0);
        },
        addToBag: async function() {
            if (app.processingBag) return;
            app.processingBag = true;

            const savedLocalItems = localStorage.getItem(window.boxLocalStorageId) ? JSON.parse(localStorage.getItem(window.boxLocalStorageId)) : false;
            const glazehwBoxes = savedLocalItems ? savedLocalItems : [];
            const items = app.products.map(product => ({
                id: product.first_available_variant.id,
               type: product.type,
                quantity: 1,
                properties: {
                    SKU: product.first_available_variant.sku,
                    box_id: app.isEditMode ? app.editBoxId : glazehwBoxes.length + 1,
                    box_type: 'glazehw',
                  'Job/Tag': $('.po-number').val(),
                  'Cut Length': $('#cut-length').val(),
                  
                }
            }));

                        console.log(items);
            const uniqueItems = [];
            const exists = new Set();
            items.forEach(item => {
                if (!exists.has(item.id)) {
                    exists.add(item.id);
                  if(item.type == 'hinges') item.quantity = 2;
                    else if (item.type == 'clamps') item.quantity = 3;
                     else if (item.type == 'drills') item.quantity = 10;
                      else item.quantity = Math.max(1, items.filter(product => item.id === product.id).length);
                    uniqueItems.push(item);
                }
            });

            if (app.isEditMode) {
                // savedLocalItems[app.editBoxId - 1] = uniqueItems;
                // localStorage.setItem(window.boxLocalStorageId, JSON.stringify(savedLocalItems));

                // const cartItems = await fetch(`${window.Shopify.routes.root}cart.js`).then(res => res.json()).then(res => res.items);

                // let newBag = [];
                // cartItems.forEach(item => {
                //     if (parseInt(item.properties.box_id) === parseInt(app.editBoxId)) return;
                //     newBag.push({
                //         id: item.id,
                //         quantity: item.quantity,
                //         properties: item.properties
                //     });
                // });

                // newBag = [...newBag, ...uniqueItems];

                // await fetch(`${window.Shopify.routes.root}cart/clear.js`);
                // await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                //     method: 'POST',
                //     headers: {
                //         'Content-Type': 'application/json'
                //     },
                //     body: JSON.stringify({
                //         items: newBag.reverse()
                //     })
                // });

                // window.location = `/cart`;
            } else {

              console.log(uniqueItems);
                glazehwBoxes.push(uniqueItems);
                fetch(`${window.Shopify.routes.root}cart/add.js`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        items: uniqueItems
                    })
                })
                .then(res => res.json())
                .then(res => {
                    app.processingBag = false;
                    localStorage.setItem(window.boxLocalStorageId, JSON.stringify(glazehwBoxes));
                    window.location = `/cart`;
                })
                .catch(error => {
                    console.log(error);
                    app.processingBag = false;
                    alert('There was an error adding the products to your cart. Please try again later.');
                });
            }
        },
        toggleMobileBag: function() {
            app.collapsedMobileBag = !app.collapsedMobileBag;
        },
        bindEvents: function() {

              $('.builder-hidden-scroll button').on('click', function() {
        const tabIndex = this.id.split('-').pop();

                 app.switchTab(tabIndex);
                
    });

          
            $(document).on('click', '.switch-tab', function() {
                app.switchTab($(this).data('tab'));
            });

            $(document).on('click', '.add-to-bundle', function() {
              current_variant = $(this).parents('.relative.bg-white.rounded-lg.border-solid').find('.bundle-product:checked').data('variant-data');
                app.addToBundle($(this).data('product'),$(this).data('type'), current_variant);
            });

          

          $(document).on('change', '.bundle-product', function() {
            let var_data = $(this).data('variant-data');
            $(this).parents('.pt-main-product').find('.font-light.font-vinyl.text-zinc-900.text-sm').html(Shopify.formatMoney(var_data.price, money_format));
            $(this).parents('.pt-main-product').find('img').attr('src', var_data.featured_image.src);
            $(this).parents('.pt-main-product').find('.var-sku').text(var_data.sku);
          });
            $(document).on('click', '.remove-bundle', function() {
                app.removeFromBundle($(this).data('uid'));
            $(this).parents('.added-product').remove();

              let type = $(this).data('type');
                 if(type == 'hinges'){
               $('#bundle-builder-section-tab-1 .add-to-bundle').removeClass('disabled').removeAttr('disabled');
              }
              else if(type == 'handles'){
               $('#bundle-builder-section-tab-2 .add-to-bundle').removeClass('disabled').removeAttr('disabled');
              } else if(type == 'clamps'){
               $('#bundle-builder-section-tab-3 .add-to-bundle').removeClass('disabled').removeAttr('disabled');
              }
                  
            if ($('.replace-hinges.replaced .added-product').length > 0 && $('.replace-clamps.replaced .added-product').length > 0 && $('.replace-handles.replaced .added-product').length> 0) $('.add-to-bag').removeClass('disabled').removeAttr('disabled');
                else $('.add-to-bag').addClass('disabled').attr('disabled',true);
              
              
            });

            $(document).on('click', '.add-to-bag', function() {
                app.addToBag();
            });

            $(document).on('click', '.toggle-mobile-bag', function() {
                app.toggleMobileBag();
            });
        }
    };

    $(document).ready(function() {
        app.init();
    });
}





